import useLocales from 'src/careflow/ph-core/internationalization/hook/useLocales';
import CustomButton, { CustomButtonProps } from './CustomButton';
import { spreadSxProp } from 'src/utils/cssStyles';

export interface CancelButtonProps extends CustomButtonProps {}

const CancelButton = ({ children, sx, ...buttonProps }: CancelButtonProps) => {
  const { i18n } = useLocales();
  const dataName = (buttonProps as any)['data-name'];
  const { 'data-name': _, ...restProps } = buttonProps as any;
  
  return (
    <CustomButton
      sx={[
        {
          color: '#212b36',
          width: 78,
          border: 0,
          mr: 1.2,
          '&:hover': { border: 0 },
        },
        ...spreadSxProp(sx),
      ]}
      variant="outlined"
      color="inherit"
      data-name={dataName || 'cancel-button'}
      {...restProps}
    >
      {children ? children : i18n('cancel')}
    </CustomButton>
  );
};

export default CancelButton;
